var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var CheckMarkImage = function () {
    return (_jsx("svg", __assign({ width: "16", height: "12", viewBox: "0 0 16 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M0.205671 7.96025L3.25834 11.0129C4.11676 11.8711 5.50826 11.8711 6.36669 11.0129L15.7943 1.58528C16.0755 1.29418 16.0674 0.830314 15.7763 0.549176C15.4923 0.274908 15.0421 0.274908 14.7582 0.549176L5.33058 9.97681C5.04443 10.2629 4.5806 10.2629 4.29448 9.97681L1.24181 6.92414C0.950711 6.64301 0.486843 6.65108 0.205705 6.94218C-0.0685627 7.22613 -0.0685627 7.67629 0.205671 7.96025Z", fill: "#14181F" }) })));
};
